import { render, staticRenderFns } from "./FiltrosAdicionais.vue?vue&type=template&id=738d888c"
import script from "./FiltrosAdicionais.vue?vue&type=script&lang=js"
export * from "./FiltrosAdicionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports